<ex-dropdown
  #dropdown
  size="small"
  noInput
  noInputMargin
  noBorder
  noChevron
  container="body"
  [overlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
  ]"
  paddedItemsContainer
>
  <ng-template exDropdownDisplay>
    @if (!this.databaseBookmarkPaths.length) {
      <ex-button size="medium" type="primary" variant="raised" icon="folder-fill">
        {{ 'folder.save' | translate }}
      </ex-button>
    } @else {
      <ex-button size="medium" type="success" variant="raised" icon="folder-fill">
        {{ 'folder.saved' | translate }} ({{ this.databaseBookmarkPaths.length }})
      </ex-button>
    }
  </ng-template>

  <ng-template exDropdownContent>
    <div class="px-2 py-2">
      <div class="input-container">
        <i class="ph ph-magnifying-glass"></i>
        <input
          #searchInput
          autoselect
          data-cy="saving-panel-search-input"
          type="text"
          [formControl]="filterText"
          class="form-control"
          placeholder="{{ 'folder.search-placeholder' | translate }}"
          (keyup)="filterBookmarks()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); onInputEnter()"
          (keydown.tab)="$event.preventDefault(); $event.stopPropagation()"
        />
        @if (filterText.value?.length) {
          <i
            (click)="$event.stopPropagation(); filterText.setValue(''); filterBookmarks(); searchInput.focus()"
            class="ph ph-x-circle cursor-pointer"
          ></i>
        }
      </div>
      @if (!filterText.value?.length) {
        <div class="font-12px fw-600 px-1 py-1">
          {{ 'folder.select-or-create-folder' | translate }}
        </div>
      }
      @if (folderList) {
        @if (filterText.value && isUnique(filterText.value)) {
          <div
            id="new-folder-button"
            data-cy="new-folder"
            class="color-basic-900 d-flex align-items-center py-2 gap-2 cursor-pointer"
            (click)="createFolder(filterText.value.trim())"
          >
            <i class="ph-fill ph-plus-square font-16px"></i>
            <span class="checkbox-label"
              >Créer <span class="fw-600">"{{ filterText.value.trim() }}"</span></span
            >
          </div>
        }
        @if (filteredFolderList.length) {
          <div class="folder-list">
            @if (!folderList.length) {
              <p class="placeholder-no-folder">
                <span>{{ 'folder.no-folder-yet' | translate }}</span>
                <span>{{ 'folder.no-folder-create-first' | translate }}</span>
              </p>
            }
            @for (folder of filteredFolderList; track folder.id) {
              <div [id]="'folder-' + folder.id" data-cy="save-panel-folder-line" class="d-flex">
                <label class="container d-flex">
                  <span class="d-flex font-12px w-100">
                    <span
                      class="text-limited-1-line fw-600"
                      overflowTooltip
                      [ngbTooltip]="folder.name"
                      tooltipClass="simple-tooltip"
                      [openDelay]="500"
                      placement="bottom auto"
                    >
                      {{ folder.name }}</span
                    ><span class="ps-1 fw-600">({{ folder.documentsCount }})</span>
                  </span>
                  <input
                    data-cy="save-panel-folder-line-checkbox"
                    type="checkbox"
                    class="form-check-input"
                    [checked]="folder.containsDocument"
                    (click)="toggleCheckbox($event, folder)"
                  />
                  <span class="checkmark"></span>

                  @if (folder.id === folderId) {
                    <span class="this-folder-badge">{{ 'folder.this-folder-badge' | translate }}</span>
                  }
                </label>
              </div>
            }
          </div>
        }

        <mat-divider class="color-basic-500"></mat-divider>
        <div class="d-table pt-2">
          <span class="folder-separator d-table-cell align-content-center"></span>
          <div class="d-flex align-items-end gap-2">
            <ex-button type="primary" variant="ghost" (click)="cancel(); dropdown.show = false">
              {{ 'folder.cancel-button' | translate | titlecase }}
            </ex-button>
            <ex-button
              type="primary"
              variant="raised"
              (click)="updateBookmarks(); dropdown.show = false"
              [disabled]="!hasUnsavedChanges()"
              data-cy="folder-save-button"
              >{{ 'folder.save' | translate | titlecase }}
            </ex-button>
          </div>
        </div>
      }
    </div>
  </ng-template>
</ex-dropdown>
